import { useSelector } from 'hooks/utils';
import { selectProjectFileById } from 'store/data/documents';

export function useProjectDocumentById(fileId: string) {
	return useSelector(state => selectProjectFileById(state.data.documents, fileId));
}
